export default function ShopCreditLegend() {
  return (
    <div className="shop-credit-legend" aria-label="راهنمای رنگ کارت فروشگاه">
      <div className="shop-credit-legend-item">
        <span className="shop-credit-legend-dot shop-credit-legend-dot-red" />
        <span>قرمز — پایان اعتبار (مبلغ یا زمان)</span>
      </div>
      <div className="shop-credit-legend-item">
        <span className="shop-credit-legend-dot shop-credit-legend-dot-yellow" />
        <span>زرد — سفارش اعتباری + اعتبار باقی‌مانده</span>
      </div>
    </div>
  );
}
